var _g, _rect, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShootingSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219 45"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shooting-switch_svg__filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 4.5,
    width: 78,
    height: 36,
    rx: 18,
    stroke: "url(#shooting-switch_svg__paint0_linear)",
    strokeWidth: 3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.301,
    x: -30,
    y: 13,
    width: 231,
    height: 21,
    rx: 10.5,
    fill: "url(#shooting-switch_svg__paint1_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 23,
    r: 10,
    fill: "#3A5581"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shooting-switch_svg__paint0_linear",
    x1: 113.484,
    y1: 50.333,
    x2: 229.098,
    y2: 50.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A5581"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shooting-switch_svg__paint1_linear",
    x1: -30,
    y1: 34,
    x2: 201,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081122",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#487FCF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shooting-switch_svg__filter0_f",
    x: 132.282,
    y: 0.282,
    width: 86.437,
    height: 44.437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.359,
    result: "effect1_foregroundBlur"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjE5IiBoZWlnaHQ9IjQ1IiB2aWV3Qm94PSIwIDAgMjE5IDQ1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9mKSI+CjxyZWN0IHg9IjEzNi41IiB5PSI0LjUiIHdpZHRoPSI3OCIgaGVpZ2h0PSIzNiIgcng9IjE4IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcikiIHN0cm9rZS13aWR0aD0iMyIvPgo8L2c+CjxyZWN0IG9wYWNpdHk9IjAuMzAxMDYiIHg9Ii0zMCIgeT0iMTMiIHdpZHRoPSIyMzEiIGhlaWdodD0iMjEiIHJ4PSIxMC41IiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIi8+CjxjaXJjbGUgY3g9IjE5MSIgY3k9IjIzIiByPSIxMCIgZmlsbD0iIzNBNTU4MSIvPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9mIiB4PSIxMzIuMjgyIiB5PSIwLjI4MTcxOCIgd2lkdGg9Ijg2LjQzNjYiIGhlaWdodD0iNDQuNDM2NiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxLjM1OTE0IiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXIiLz4KPC9maWx0ZXI+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjExMy40ODQiIHkxPSI1MC4zMzI4IiB4Mj0iMjI5LjA5OCIgeTI9IjUwLjMzMjgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzBFMTkzMiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMzQTU1ODEiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyIiB4MT0iLTMwIiB5MT0iMzQiIHgyPSIyMDEiIHkyPSIzNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDgxMTIyIiBzdG9wLW9wYWNpdHk9IjAuMDEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDg3RkNGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgShootingSwitch as ReactComponent };